import { CustomerRequest } from '@app/models/customer/CustomerRequest';
import { CustomerResponse } from '@app/models/customer/CustomerResponse';
import { Parameters, UsersTableData, UsersTableRow, UsersResponse, UserApiData } from '@app/models/user/UserResponse';
import { UserRequest } from '@app/models/user/UserRequest';
import { post, get } from './http.api';
import { UserDTO } from '@app/models/user/UserDTO';
import { ResetUserPassword } from '@app/models/user/ResetUserPassword';

export const updateUserProfile = async (id: number, userData: CustomerRequest) => {
  try {
    const { data, status } = await post<any>(`users/${id}/profile`, userData, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getUserProfile = async (id: number): Promise<UserDTO> => {
  try {
    const { data, status } = await get<UserDTO>(`users/${id}/profile`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getUsersTableData = async (parameters: Parameters): Promise<UsersTableData> => {
  try {
    const { data, status } = await get<any>('users', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data:`, data);

    const users: UsersTableRow[] = data.users.data.map((userData: any) => ({
      id: userData.id,
      username: userData.username,
      email: userData.email,
    }));

    return {
      data: users,
      pagination: {
        current: data?.users?.current_page,
        pageSize: data?.users?.per_page,
        total: data?.users?.total,
      },
      statusOptions: data.status_options,
    };
  } catch (error: any) {
    console.error('Error fetching user roles:', error);
    throw error;
  }
};

export const getAllUserRoles = async (): Promise<UsersResponse> => {
  try {
    const { data, status } = await get<UsersResponse>(`users`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getUserRoleById = async (id: number): Promise<UsersResponse> => {
  try {
    const { data, status } = await get<UsersResponse>(`users/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeUser = async (userRoleData: UserRequest) => {
  try {
    const response = await post<any>('users/create', userRoleData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createUsers = async (): Promise<UserApiData> => {
  try {
    const { data, status } = await get<UserApiData>(`users/create`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showUser = async (id: number) => {
  try {
    const { data, status } = await get<UserApiData>(`users/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editUser = async (id: number) => {
  try {
    const { data, status } = await get<UserApiData>(`users/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateUser = async (id: number, UpdateUserData: UserRequest) => {
  try {
    const { data, status } = await post<UserRequest>(`users/${id}/edit`, UpdateUserData, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const resetPassword = async (id: number, updateData: ResetUserPassword) => {
  try {
    const { data, status } = await post<any>(`users/${id}/reset_password`, updateData, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};
